const KType = [
    {id: "0", value: "實體"},    
    {id: "1", value: "上影線"},
    {id: "2", value: "下影線"},
  ];  
  export default KType  